"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.list.title': '职业行业',
    'branch.list.empty': '未找到行业',
};
